export default "__VITE_ASSET__BmBqQBrB__"